<!--
    file type .....: HTML file: automatch.component.html
    Created By ....: ianday
    Date ..........: 2/28/24 
-->
<div class="automatch-container">
    <div class="integration-container">
        <div class="heading-text-style">Automatch Process</div>

        <div class="dwform" style="margin-left:20px">

            <div class="dwform-row-gap"></div>

            <label class="label-field label-field-override">Enable/Disable:</label>
            <label class="form-required"> </label>

            <dw-dropdown [disabled]="!visibleModify"
                    [selectedItem]="selectedValue"
                    [dataSource]="enabledList"
                    [controlWidth]="'180px'"
                    (itemSelected)="selectedValue = $event;updateIntegrationStatus($event)"></dw-dropdown>

            <div class="dwform-row-gap"></div>
            <div class="dwform-row-gap"></div>

            <label class="label-field label-field-override">Service Status:</label>
            <label class="form-required"> </label>

            <label [ngStyle]="settingsRecord.value === 'true' ? {'color':'green'} : {'color':'red'}">
                {{currentRunState}}
            </label>

            <div class="dwform-row-gap"></div>
            <div class="dwform-row-gap"></div>

            <label class="label-field label-field-override">Matched Requests Today:</label>
            <label class="form-required"> </label>
            <label>{{ successCount }}</label>

            <div class="dwform-row-gap"></div>
            <div class="view-log">
                <button mat-button class="command-button" (click)="doOpenViewLog()">
                    <mat-icon>search</mat-icon>View Log</button>
            </div>
        </div>
    </div>

 </div>

<p-dialog header="Auto Match Log (Press Escape to close)" [focusOnShow]="false" [showHeader]="true"
          [(visible)]="viewLogDlg"
          [modal]="true"
          [style]="{width: '850px', height: '600px'}"
          appendTo="body"
          [minY]="35" [resizable]="true" [closable]="true" >
    <div class="canvas-area"
         style="display: block;vertical-align: top">
        <span style="font-size: 9pt;width:100%; height:100%;" [innerHtml]="logContent"></span>
    </div>
</p-dialog>
